import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Card,
    CardContent,
    CardHeader, Divider, Grid, Link, Table,
    TableBody,
    TableCell, TableRow, Typography
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { StoricoUfficioContext } from '../StoricoUfficioContext';


const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const ContattoDetails = ({
    disabled,
    contatto,
    previousContatto,
    isDeleted,
    ...props }) => {

    const {
        state,
        setState,
    } = useContext(StoricoUfficioContext);

    const {
        storicoUfficio
    } = state;

    const buildTableCellRowComponent = (key, value, oldValue) => {

        if (isDeleted) {
            return (<TableRow>
                <TableCell style={{ width: "20%" }}>
                    {key}
                </TableCell>
                <TableCell>

                    <div style={{
                        //    textDecoration:'line-through',
                        //    color:'red'
                    }}>

                        {!oldValue ? <span style={{
                            textDecoration: 'none',

                            padding: '4px',
                            marginRight: '8px',
                            borderRadius: '8px',
                            fontSize: '0.8em',
                            backgroundColor: 'rgba(255, 0, 0, 0.40)'
                        }}>Eliminato</span> : <div />}
                        {value ?? '-'}
                    </div>

                </TableCell>
            </TableRow>);



        } else {
            return (<TableRow>
                <TableCell style={{ width: "20%" }}>
                    {key}
                </TableCell>
                <TableCell>

                    <div style={{
                    }}>

                        {!oldValue && oldValue != value ? <span style={{
                            padding: '4px',
                            marginRight: '8px',
                            borderRadius: '8px',
                            fontSize: '0.8em',
                            backgroundColor: 'rgba(0, 255, 0, 0.40)'
                        }}>Nuovo</span> : <div />}
                        {value ?? '-'}
                    </div>
                    {(oldValue && value != oldValue ? <div style={{
                        //backgroundColor: 'rgba(255, 0, 0, 0.6)',
                        textDecoration: 'line-through',
                        color: 'red'
                    }}>
                        {oldValue}
                    </div> : <div />)}
                </TableCell>
            </TableRow>);
        }
    }


    return (
        <>
            <Card sx={{ marginTop: 3 }}>
                <CardHeader
                    sx={{
                        color: "white",
                        backgroundColor: "secondary.main",
                    }}
                    title={
                        <Grid container alignItems="center" justify="space-between">
                            <Grid item>
                                <Typography variant="h6">{contatto.Descrizione}</Typography>
                            </Grid>
                        </Grid>
                    }
                />
                <Divider />
                <CardContent sx={{ padding: "0px !important" }}>
                    <Table>
                        <TableBody>
                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Descrizione
                                </TableCell>
                                <TableCell>
                                    {contatto.Descrizione ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Descrizione", contatto.Descrizione, previousContatto?.Descrizione)}
                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Valore
                                </TableCell>
                                <TableCell>
                                    {contatto.Valore ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Valore", contatto.Valore, previousContatto?.Valore)}
                            {/* 
                            <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Inizio validità
                                </TableCell>
                                <TableCell>
                                    {contatto.InizioValidita?.toLocaleDateString("it-IT") ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Inizio validità", contatto.InizioValidita?.toLocaleDateString("it-IT"), previousContatto?.InizioValidita?.toLocaleDateString("it-IT"))}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Fine validità
                                </TableCell>
                                <TableCell>
                                    {contatto.FineValidita?.toLocaleDateString("it-IT") ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Fine validità", contatto.FineValidita?.toLocaleDateString("it-IT"), previousContatto?.FineValidita?.toLocaleDateString("it-IT"))}

                            {
                                contatto.Contatti && contatto.Contatti.length > 0 &&
                                <TableRow>
                                    <TableCell style={{ width: "20%" }}>
                                        Attributi
                                    </TableCell>
                                    <TableCell>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                                aria-controls="contatti-panel"
                                                id="contatti-panel"
                                                sx={{
                                                    color: "white",
                                                    backgroundColor: "secondary.main",
                                                }}
                                            >
                                                <Typography variant="h6">Contatti</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {
                                                    contatto.Contatti.map((e, index) => {
                                                        var previousVal = previousContatto?.Contatti?.find(x => x.Id == e.Id);
                                                        return (<Grid key={index} item xs={12}>
                                                            <ContattoDetails
                                                                contatto={e}
                                                                previousContatto={previousVal}
                                                            />
                                                        </Grid>);
                                                    })


                                                }
                                                {
                                                    previousContatto?.Contatti?.filter(x => contatto?.Contatti?.map(y => y.Id).indexOf(x.Id) < 0).map((e, index) => {
                                                        return (<Grid key={index} item xs={12}>
                                                            <ContattoDetails
                                                                contatto={e}
                                                                previousContatto={null}
                                                                isDeleted={true}
                                                            />
                                                        </Grid>)
                                                    })
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                        <Divider />
                                    </TableCell>
                                </TableRow>
                            }



                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </>
    );
}